import { FC } from 'react';
import { OptionType } from 'components/Select/Select';
import { useQueryState } from 'hooks/useQueryState';
import NonGraniteTables from './NonGranite';
import GraniteServicesTable from './GraniteServicesTable';

export type ViewType = 'all' | 'active' | 'deactivated' | 'non-granite';

interface ServicesTableProps {
  selectedTableView: OptionType;
  setTableView: (selectedTableView: OptionType) => void;
}

const ServicesTable: FC<ServicesTableProps> = ({
  selectedTableView,
  setTableView,
}) => {
  const [activeTab, setActiveTab] = useQueryState('view', {
    defaultValue: 'all',
    getParam: (value: string) => value as ViewType,
    setParam: (value: ViewType) => value,
  });

  return (
    <>
      {activeTab === 'non-granite' ? (
        <NonGraniteTables
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          selectedTableView={selectedTableView}
          setTableView={setTableView}
        />
      ) : (
        <GraniteServicesTable
          selectedTableView={selectedTableView}
          setTableView={setTableView}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      )}
    </>
  );
};

export default ServicesTable;
